module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 12 21",
      url: __webpack_public_path__ + "svg-sprite.svg#facebook",
      toString: function () {
        return this.url;
      }
    }